/**
 * RoleGuardedRoute Component
 * Blocks access to routes below the user's role level.
 * Redirects to dashboard if user doesn't meet the minimum level.
 */
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export default function RoleGuardedRoute({ children, minLevel = 0 }) {
    const { user, maxRoleLevel, isSuperAdmin, isLoading } = useAuth();

    if (isLoading) return null;

    // SuperAdmins bypass all level checks
    if (isSuperAdmin()) return children;

    // Check if user meets the minimum level
    if (maxRoleLevel < minLevel) {
        console.warn(`[RoleGuard] Access denied: user level ${maxRoleLevel} < required ${minLevel}`);
        return <Navigate to="/internal/dashboard" replace />;
    }

    return children;
}
